import { render, staticRenderFns } from "./PubliciPage.vue?vue&type=template&id=481ec6c3&"
import script from "./PubliciPage.vue?vue&type=script&lang=js&"
export * from "./PubliciPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports